import { LabelsContext, ThemeContext } from 'helpers/contexts';
import React, { useContext } from 'react';
import * as S from './style';
import * as Constant from 'constant';
import FireberryLogo from 'images/FireberryLogo.png';
import Text from 'components/common/Text';
import { TextInput } from 'components/common/Input';
import LoadingButton from 'components/common/LoadingButton';
import { LegalDocuments } from 'components/features/LegalDocuments';
import { FormContainer, Img, MobileContentContainer, MobileHeadlineContainer } from '../style';

export function MobileCredentialPage(props) {
  const { colors } = useContext(ThemeContext);
  const { signUp, global } = useContext(LabelsContext);

  return (
    <S.MobileCredentialPageContainer bgColor={colors.white}>
      <MobileHeadlineContainer>
        <Img src={FireberryLogo} width={'197px'} />
        <Text size={Constant.SIZE.xxl}>{signUp.credentialsPage.headline}</Text>
      </MobileHeadlineContainer>
      <FormContainer mobileMarginTop={'40px'}>
        <MobileContentContainer>
          <S.InputsContainer>
            <S.InputContainer borderColor={colors.gray.gray400}>
              <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.name'}>
                <TextInput
                  size={Constant.SIZE.large}
                  width={Constant.FULL_LENGTH}
                  value={props.fullName}
                  placeholder={signUp.personalDetails.fullName}
                  variant={Constant.VARIENT.empty}
                  onChange={props.onFullNameChange}
                  autoFocus
                />
              </S.InputWrapper>
              {props.fullNameError && (
                <S.ErrorContainer isRtl={props.isRtl} top={ERROR_TOP}>
                  <Text size={Constant.SIZE.xxs} color={colors.red.salmon}>
                    {props.fullNameError}
                  </Text>
                </S.ErrorContainer>
              )}
            </S.InputContainer>
            <S.InputContainer>
              <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.phone'}>
                <TextInput
                  placeholder={signUp.credentialsPage.telephone}
                  value={props.phoneNumberValue}
                  size={Constant.SIZE.large}
                  onChange={props.onPhoneNumberChange}
                  width={Constant.FULL_LENGTH}
                  type={Constant.TEXT_INPUT_TYPE.telephone}
                  variant={Constant.VARIENT.empty}
                />
              </S.InputWrapper>
              {props.phoneNumberError && (
                <S.ErrorContainer isRtl={props.isRtl} top={ERROR_TOP}>
                  <Text size={Constant.SIZE.xxs} color={colors.red.salmon}>
                    {props.phoneNumberError}
                  </Text>
                </S.ErrorContainer>
              )}
            </S.InputContainer>
            <S.InputContainer>
              <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.email'}>
                <TextInput
                  size={Constant.SIZE.large}
                  withBorder
                  value={props.emailValue}
                  type={Constant.TEXT_INPUT_TYPE.email}
                  placeholder={signUp.credentialsPage.email}
                  variant={Constant.VARIENT.empty}
                  onChange={props.onEmailChange}
                  width={Constant.FULL_LENGTH}
                />
              </S.InputWrapper>
              {props.emailErr && (
                <S.ErrorContainer isRtl={props.isRtl} top={ERROR_TOP}>
                  <Text size={Constant.SIZE.xxs} color={colors.red.salmon}>
                    {props.emailErr}
                  </Text>
                </S.ErrorContainer>
              )}
            </S.InputContainer>
            <S.InputContainer>
              <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.password'}>
                <TextInput
                  size={Constant.SIZE.large}
                  withBorder
                  type={Constant.TEXT_INPUT_TYPE.password}
                  value={props.passwordValue}
                  placeholder={signUp.credentialsPage.password}
                  variant={Constant.VARIENT.empty}
                  onChange={props.onPasswordChange}
                  width={Constant.FULL_LENGTH}
                />
              </S.InputWrapper>
              {props.showPasswordError && (
                <S.ErrorContainer isRtl={props.isRtl} top={ERROR_TOP}>
                  <Text size={Constant.SIZE.xxs} color={colors.red.salmon}>
                    {props.passwordErr}
                  </Text>
                </S.ErrorContainer>
              )}
            </S.InputContainer>
          </S.InputsContainer>
          <S.ButtonContainer data-tid={'signup.firstscreen.nextbutton'}>
            <LoadingButton
              id={'step1'}
              text={global.next}
              color={Constant.COLOR.dark}
              size={Constant.SIZE.xl}
              rounded
              isLoading={props.isLoading}
              width={'100%'}
              onClick={props.onSubmit}
            />
          </S.ButtonContainer>
          <LegalDocuments isRtl={props.isRtl} isMobile={true} />
        </MobileContentContainer>
      </FormContainer>
      <S.HaveAccountContainer marginTop={'5%'} data-tid={'signup.firstscreen.login'}>
        <Text color={colors.gray.charcoal} size={Constant.SIZE.small}>
          {signUp.credentialsPage.haveAccount}
        </Text>
        <Text color={colors.gray.charcoal} size={Constant.SIZE.small} underline onClick={props.onLoginClick}>
          {signUp.credentialsPage.clickHere}
        </Text>
      </S.HaveAccountContainer>
    </S.MobileCredentialPageContainer>
  );
}

const ERROR_TOP = '110%';
export default MobileCredentialPage;
